export default __webpack_public_path__ + "static/linkedin-d67e7b78b6c94e69f0e1e71b07070878.png";